module.exports = __webpack_public_path__ + "static/media/LeafGreen.066800bb.mp3";